import { isNumber } from 'lodash';
import pluralize from 'pluralize';

import { t } from '@lib/translation';

const HOUR = 3600;
const MINUTE = 60;

export function duration(time: any, verbose: boolean): string {
  if (!time) {
    return;
  }

  if (!isNumber(time)) {
    return 'Invalid duration format';
  }

  time = Math.abs(parseInt(time.toString(), 10));

  const pieces = {
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  let output = '';
  let remainder = time;

  const hours = remainder / HOUR;
  if (hours >= 1) {
    pieces.hours = Math.floor(hours);
    if (verbose) {
      const hourText = pluralize('hour', pieces.hours) as 'hour' | 'hours';
      output += `${pieces.hours} ${t(`common.duration.${hourText}`)} `;
    } else {
      output += `${pieces.hours}h `;
    }
    remainder = remainder - pieces.hours * HOUR;
  }

  const minutes = remainder / MINUTE;
  if (minutes >= 1) {
    pieces.minutes = Math.floor(minutes);
    if (verbose) {
      const minuteText = pluralize('minute', pieces.minutes) as 'minute' | 'minutes';
      output += `${pieces.minutes} ${t(`common.duration.${minuteText}`)} `;
    } else {
      output += `${pieces.minutes}m `;
    }
    remainder = remainder - pieces.minutes * MINUTE;
  }

  if (remainder) {
    pieces.seconds = Math.round(remainder);
    if (verbose) {
      const secondText = pluralize('second', pieces.seconds) as 'second' | 'seconds';
      output += `${pieces.seconds} ${t(`common.duration.${secondText}`)} `;
    } else {
      output += `${pieces.seconds}s `;
    }
  }

  return output.trim();
}
